import { render, staticRenderFns } from "./air-device.vue?vue&type=template&id=64692e00&scoped=true"
import script from "./air-device.vue?vue&type=script&lang=js"
export * from "./air-device.vue?vue&type=script&lang=js"
import style0 from "./air-device.vue?vue&type=style&index=0&id=64692e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64692e00",
  null
  
)

export default component.exports